export const isInternalToken = (owner: string): boolean => owner === "saleor";
